{
  "title": "Title",
  "album": "Album",
  "artist": "Artist",
  "year": "Date",
  "comment": "Comment",
  "synopsis": "Synopsis",
  "externalLink": "External link",
  "composer": "Composer",
  "copyright": "Copyright",
  "size": "Size",
  "bit_rate": "Bit rate"
}
